module.exports = __webpack_public_path__ + "img/login-bg.a3d988fa.png";